import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
interface PrivacyModalProps {
  isOpen: boolean;
  onClose: () => void;
}
export function PrivacyModal({
  isOpen,
  onClose
}: PrivacyModalProps) {
  return <AnimatePresence data-id="element-126">
      {isOpen && <>
          <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} onClick={onClose} className="fixed inset-0 bg-black/60 z-50 backdrop-blur-sm" data-id="element-127" />
          <motion.div initial={{
        opacity: 0,
        y: 50,
        scale: 0.95
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 20,
        scale: 0.95
      }} className="fixed left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-full max-w-2xl bg-cream-100 rounded-2xl shadow-2xl z-50 max-h-[85vh] flex flex-col overflow-hidden" data-id="element-128">
            <div className="flex items-center justify-between p-6 border-b border-cream-200 bg-white" data-id="element-129">
              <h2 className="text-2xl font-heading font-bold text-forest-900" data-id="element-130">
                Privacy Policy
              </h2>
              <button onClick={onClose} className="p-2 text-gray-500 hover:text-forest-700 hover:bg-cream-200 rounded-full transition-colors" aria-label="Close modal" data-id="element-131">
                <X size={24} data-id="element-132" />
              </button>
            </div>

            <div className="p-6 overflow-y-auto prose prose-green max-w-none" data-id="element-133">
              <p className="text-sm text-gray-500 mb-6" data-id="element-134">
                Last Updated: {new Date().toLocaleDateString()}
              </p>

              <h3 className="text-lg font-bold text-forest-900 mt-6 mb-3" data-id="element-135">
                1. Information We Collect
              </h3>
              <p className="text-gray-700 mb-4" data-id="element-136">
                Pancho's Lawn Care collects personal information that you
                voluntarily provide to us when you express an interest in
                obtaining information about us or our services. The personal
                information that we collect depends on the context of your
                interactions with us, and may include your name, phone number,
                email address, and property address for service estimates.
              </p>

              <h3 className="text-lg font-bold text-forest-900 mt-6 mb-3" data-id="element-137">
                2. How We Use Your Information
              </h3>
              <p className="text-gray-700 mb-4" data-id="element-138">
                We use personal information collected via our website for a
                variety of business purposes described below. We process your
                personal information for these purposes in reliance on our
                legitimate business interests, in order to enter into or perform
                a contract with you, with your consent, and/or for compliance
                with our legal obligations. We use the information we collect or
                receive to:
              </p>
              <ul className="list-disc pl-5 text-gray-700 mb-4 space-y-2" data-id="element-139">
                <li data-id="element-140">Provide quotes and estimates for landscaping services.</li>
                <li data-id="element-141">Schedule and fulfill service appointments.</li>
                <li data-id="element-142">Respond to user inquiries and offer support to users.</li>
                <li data-id="element-143">Send administrative information to you.</li>
              </ul>

              <h3 className="text-lg font-bold text-forest-900 mt-6 mb-3" data-id="element-144">
                3. Will Your Information Be Shared?
              </h3>
              <p className="text-gray-700 mb-4" data-id="element-145">
                We only share information with your consent, to comply with
                laws, to provide you with services, to protect your rights, or
                to fulfill business obligations. We do not sell your personal
                information to third parties.
              </p>

              <h3 className="text-lg font-bold text-forest-900 mt-6 mb-3" data-id="element-146">
                4. Contact Us
              </h3>
              <p className="text-gray-700 mb-4" data-id="element-147">
                If you have questions or comments about this notice, you may
                contact us at:
                <br data-id="element-148" />
                <strong data-id="element-149">Phone:</strong> (815) 354-0484
                <br data-id="element-150" />
                <strong data-id="element-151">Service Area:</strong> Northern Illinois & Southern
                Wisconsin
              </p>
            </div>

            <div className="p-6 border-t border-cream-200 bg-white flex justify-end" data-id="element-152">
              <button onClick={onClose} className="px-6 py-2 bg-forest-700 text-white rounded-lg font-medium hover:bg-forest-900 transition-colors" data-id="element-153">
                Close
              </button>
            </div>
          </motion.div>
        </>}
    </AnimatePresence>;
}